export default __webpack_public_path__ + "static/media/30_tag_smoking-area.699f0e4b.svg";